"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ExpandItem = exports.ExpandBtn = exports.ExpandWrapper = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _animations = require("@staccx/animations");

var _Caret = _interopRequireDefault(require("../Icons/Caret"));

var _themeContants = require("../../constants/themeContants");

var _ThemeComponent = _interopRequireDefault(require("../Theme/ThemeComponent"));

var _theming = require("../../theming");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Expand = function Expand(_ref) {
  var className = _ref.className,
      _ref$expanded = _ref.expanded,
      expanded = _ref$expanded === void 0 ? false : _ref$expanded,
      onClick = _ref.onClick,
      children = _ref.children,
      title = _ref.title,
      hideIcon = _ref.hideIcon,
      variant = _ref.variant,
      restProps = _objectWithoutProperties(_ref, ["className", "expanded", "onClick", "children", "title", "hideIcon", "variant"]);

  var _useState = (0, _react.useState)(expanded),
      _useState2 = _slicedToArray(_useState, 2),
      isExpanded = _useState2[0],
      setIsExpanded = _useState2[1];

  var handleExpand = function handleExpand(event) {
    setIsExpanded(!isExpanded);

    if (onClick) {
      onClick(event);
    }
  };

  return _react["default"].createElement(ExpandWrapper, _extends({
    className: className,
    variant: variant
  }, restProps), _react["default"].Children.map(children, function (child, i) {
    // Ignore the first child
    if (i < 1) {
      return _react["default"].createElement(ExpandBtn, {
        title: title,
        isExpanded: isExpanded,
        onClick: function onClick(e) {
          return handleExpand(e);
        },
        "aria-expanded": isExpanded,
        "aria-controls": title,
        id: title + "2",
        variant: variant
      }, child, !hideIcon && _react["default"].createElement(ExpandIcon, {
        variant: variant,
        isExpanded: isExpanded
      }));
    }

    return isExpanded && _react["default"].createElement(ExpandItem, {
      id: title,
      "aria-labelledby": title + "2",
      variant: variant
    }, child);
  }));
};

Expand.themeProps = {
  iconComponent: {
    name: "COMPONENT_EXPAND_ICON",
    description: "Icon shown. Defaults to Caret",
    type: _themeContants.themePropTypes.component
  },
  icon: {
    name: "EXPAND_ICON",
    description: "Icon style",
    type: _themeContants.themePropTypes.style
  },
  wrapper: {
    name: "EXPAND_WRAPPER",
    description: "Wrapper style",
    type: _themeContants.themePropTypes.style
  },
  button: {
    name: "EXPAND_BTN",
    description: "Button style",
    type: _themeContants.themePropTypes.style
  },
  item: {
    name: "EXPAND_ITEM",
    description: "Item style",
    type: _themeContants.themePropTypes.style
  }
};

var IconComponent = function IconComponent(_ref2) {
  var props = _extends({}, _ref2);

  return _react["default"].createElement(_ThemeComponent["default"], _extends({
    tagName: Expand.themeProps.iconComponent.name,
    fallback: _Caret["default"]
  }, props));
};

var ExpandIcon = (0, _styledComponents["default"])(IconComponent).withConfig({
  displayName: "Expand__ExpandIcon",
  componentId: "qicxr1-0"
})(["position:absolute;right:", ";top:50%;fill:", ";transition:transform 0.3s ease-out;right:0;transform:", ";", ";"], _theming.color.small, _theming.color.wcag, function (p) {
  return p.isExpanded ? "translateY(-50%) rotate(180deg)" : "translateY(-50%) rotate(0)";
}, (0, _theming.applyVariants)(Expand.themeProps.icon.name));

var ExpandWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Expand__ExpandWrapper",
  componentId: "qicxr1-1"
})(["", ";"], (0, _theming.applyVariants)(Expand.themeProps.wrapper.name));

exports.ExpandWrapper = ExpandWrapper;

var ExpandBtn = _styledComponents["default"].button.withConfig({
  displayName: "Expand__ExpandBtn",
  componentId: "qicxr1-2"
})(["position:relative;background-color:transparent;border-width:0;color:inherit;padding:0;text-align:left;padding-right:", ";margin:0;min-height:0;width:100%;&:hover,&:focus,&:active{background-color:transparent;border-width:0;color:inherit;outline:none;", "{fill:", ";}}", ";"], _theming.spacing.mediumPlus, ExpandIcon, _theming.color.primary, (0, _theming.applyVariants)(Expand.themeProps.button.name));

exports.ExpandBtn = ExpandBtn;

var ExpandItem = _styledComponents["default"].div.withConfig({
  displayName: "Expand__ExpandItem",
  componentId: "qicxr1-3"
})(["opacity:0;animation:0.4s ", " 0.05s ease-out forwards 1;", ";"], _animations.BounceIn, (0, _theming.applyVariants)(Expand.themeProps.item.name));

exports.ExpandItem = ExpandItem;
Expand.defaultProps = {
  expanded: false,
  className: "",
  title: "",
  hideIcon: false
};
Expand.propTypes = {
  children: _themeContants.commonPropTypes.children.isRequired,
  title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element, _propTypes["default"].array]),
  className: _propTypes["default"].string,
  expanded: _propTypes["default"].bool,
  hideIcon: _propTypes["default"].bool
};
var _default = Expand;
exports["default"] = _default;